import { render, staticRenderFns } from "./MappedDataView.vue?vue&type=template&id=54ce546a&scoped=true"
import script from "./MappedDataView.vue?vue&type=script&lang=js"
export * from "./MappedDataView.vue?vue&type=script&lang=js"
import style0 from "./MappedDataView.vue?vue&type=style&index=0&id=54ce546a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce546a",
  null
  
)

export default component.exports